// src/components/dashboard/NewInCategories.jsx

export default function NewInCategories() {
  const companies = [
    {
      name: "Lumo Skincare",
      category: "Botanical Extracts",
      img: "/assets/images/sample1.png",
    },
    {
      name: "BDerm Essentials",
      category: "Colorants & Pigments",
      img: "/assets/images/sample2.png",
    },
    {
      name: "Glow Organics",
      category: "Essential Oils & Fragrances",
      img: "/assets/images/sample3.png",
    },
  ];

  return (
    <section className="bg-white py-10">
      <div className="max-w-[1200px] mx-auto px-6">
        <h2 className="text-2xl font-semibold text-center mb-8">
          New in Your Categories
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {companies.map((c, idx) => (
            <div
              key={idx}
              className="bg-white border rounded-xl shadow-sm hover:shadow-md transition"
            >
              <img
                src={c.img}
                alt={c.name}
                className="w-full h-40 object-cover"
              />
              <div className="p-4 text-center">
                <p className="font-semibold">{c.name}</p>
                <p className="text-gray-500 text-sm mb-3">{c.category}</p>

                <div className="flex justify-center gap-3">
                  <button className="bg-teal-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-teal-800">
                    View Profile
                  </button>
                  <button className="bg-teal-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-teal-800">
                    Request a Quote
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
